var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgThumbtack = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 2.25C18.75 1.83579 18.4142 1.5 18 1.5L6 1.5C5.58579 1.5 5.25 1.83579 5.25 2.25V2.25C5.25 2.66422 5.58579 3 6 3L6.75 3L6.75 9.68024C5.65079 10.9012 5.25 12.4273 5.25 14.1366V14.1366C5.25 14.6086 5.63264 14.9913 6.10465 14.9913H11.25V21.75C11.25 22.1642 11.5858 22.5 12 22.5V22.5C12.4142 22.5 12.75 22.1642 12.75 21.75V15L17.8912 14.9925C18.3634 14.9918 18.7458 14.6088 18.7458 14.1366V14.1366C18.8069 12.4884 18.3492 10.9012 17.25 9.68024V3L18 3C18.4142 3 18.75 2.66421 18.75 2.25V2.25ZM15.75 10.4128L15.9943 10.657C16.7271 11.3895 17.0668 12.4622 17.25 13.5H6.75C6.9332 12.4622 7.33399 11.3285 8.00573 10.657L8.25 10.4128V3L15.75 3L15.75 10.4128Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgThumbtack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/thumbtack.10482bb431cbcacbcea3d520a9d79248.svg";